import { Injectable } from '@angular/core';
import { NgEntityService } from '@datorama/akita-ng-entity-service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { CrowdFlowAlert } from '../../model/crowd-flow-alert';
import { WebsocketService } from '../../service/websocket.service';
import { CrowdFlowAlertsState, CrowdFlowAlertsStore } from '../state/crowd-flow-alerts.store';
import { AkitaHTTPCrowdCountDensityAlert } from './akita-http-crowdflow-density-alert';
import { AkitaHTTPCrowdFlowMotionChangeAlert } from './akita-http-crowdflow-motion-change-alert';
import { AkitaHTTPCrowdFlowMotionPatternAlert } from './akita-http-crowdflow-motion-pattern-alert';
import { AkitaHTTPCrowdFlowVelocityAlert } from './akita-http-crowdflow-velocity-alert';


@UntilDestroy()
@Injectable({ providedIn: 'root' })
export class CrowdFlowAlertsService extends NgEntityService<CrowdFlowAlertsState> {


  constructor(
    protected store: CrowdFlowAlertsStore,
    private crowdFlowDensityAlertService: AkitaHTTPCrowdCountDensityAlert,
    private crowdFlowMotionChangeAlertService: AkitaHTTPCrowdFlowMotionChangeAlert,
    private crowdFlowMotionPatternAlertService: AkitaHTTPCrowdFlowMotionPatternAlert,
    private crowdFlowVelocityAlertService: AkitaHTTPCrowdFlowVelocityAlert,
    private webSocketService: WebsocketService,
  ) {
    super(store);

    this.webSocketService.getDataStream([
      'CrowdCountDensityAlert',
      'CrowdFlowMotionChangeAlert',
      'CrowdFlowMotionPatternAlert',
      'CrowdFlowVelocityAlert',
    ]).pipe(untilDestroyed(this))
      .subscribe((data: CrowdFlowAlert[]) => this.store.upsertMany(data));
  }
  updateEntitiesUrl(newUrl: string) {
    this.crowdFlowDensityAlertService.setEntitiesUrl(newUrl);
    this.crowdFlowMotionChangeAlertService.setEntitiesUrl(newUrl);
    this.crowdFlowMotionPatternAlertService.setEntitiesUrl(newUrl);
    this.crowdFlowVelocityAlertService.setEntitiesUrl(newUrl);
  }
  /**
   * Currently uncommented!
   */
  getAll() {
    // TODO: merge map or combine latest possible
    /*
    this.crowdFlowDensityAlertService.getMaxItems(10).subscribe(alert => this.store.add(alert));
    this.crowdFlowMotionChangeAlertService.getMaxItems(10).subscribe(alert => this.store.add(alert));
    this.crowdFlowMotionPatternAlertService.getMaxItems(10).subscribe(alert => this.store.add(alert));
    this.crowdFlowVelocityAlertService.getMaxItems(10).subscribe(alert => this.store.add(alert));
    */
  }

}
